import React, { useEffect } from "react";
// react component for creating dynamic tables

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import ReactTable from "react-table";
// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { bookingApi } from "functions/apis";
import { Link } from "react-router-dom";
import Button from "components/CustomButtons/Button.js";
import { useState } from "react";
import {
  FormControl,
  Input,
  InputLabel,
  MenuItem,
  Select
} from "@material-ui/core";
import CustomInput from "components/CustomInput/CustomInput";
import { formatDateTime } from "functions/Helper";
import { token } from "functions/Helper";
import AgentDialog from "components/AgentDialog/AgentDialog";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import { formatCurrency } from "functions/Helper";

const sortOptionsList = [
  { label: "PROMO CODE ASC", value: 1 },
  { label: "PROMO CODE DESC", value: 2 },
  { label: "CREATED AT ASC", value: 3 },
  { label: "CREATED AT DESC", value: 4 }
];

const useStyles = makeStyles(styles);

export default function AgentBookingPromoCodesList() {
  const [pagination, setPagination] = React.useState({
    pageIndex: 1,
    pageSize: 10
  });
  const [filter, setFilter] = useState({
    searchString: ""
  });
  const [pages, setPages] = useState(0);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [agent, setAgent] = useState(null);
  const agentBookingPromoCodeListSignal = new AbortController();

  const getAgentBookingData = () => {
    setLoading(true);

    bookingApi
      .get("AgentBookingPromoCodes", {
        signal: agentBookingPromoCodeListSignal.signal,
        params: {
          filter,
          pagination
        }
      })
      .then(resp => {
        setData(
          resp.records.map(record => {
            return {
              ...record,
              actions: (
                <div className="actions-right">
                  {(token.is_admin === "True" ||
                    token["booking.agent_booking_promo_codes.read"] ===
                      "allowed") && (
                    <Link
                      to={"/admin/AgentBookingPromoCodes/View/" + record.id}
                    >
                      <Button
                        color="info"
                        className="like"
                        type="button"
                        value="VIEW"
                      >
                        <VisibilityIcon /> VIEW
                      </Button>
                    </Link>
                  )}

                  {(token.is_admin === "True" ||
                    token["booking.agent_booking_promo_codes.write"] ===
                      "allowed") && (
                    <Link
                      to={"/admin/AgentBookingPromoCodes/Edit/" + record.id}
                    >
                      <Button color="danger" type="button" value="CANCEL">
                        <EditIcon /> EDIT
                      </Button>
                    </Link>
                  )}

                  {(token.is_admin === "True" ||
                    token["booking.agent_booking_promo_codes.write"] ===
                      "allowed") && (
                    <Link
                      to={"/admin/AgentBookingPromoCodes/Delete/" + record.id}
                    >
                      <Button color="danger" className="like">
                        <DeleteIcon /> DELETE
                      </Button>
                    </Link>
                  )}
                </div>
              )
            };
          })
        );
        setPages(Math.ceil(data.totalRecords / pagination.pageSize));
      })
      .catch(error => console.log(error))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getAgentBookingData();
  }, [filter, pagination]);

  useEffect(() => {
    return () => {
      agentBookingPromoCodeListSignal.abort();
    };
  }, []);

  const handleSearchStringChanged = e => {
    setFilter({
      ...filter,
      searchString: e.target.value === "" ? null : e.target.value
    });
  };

  const handleSortChanged = e => {
    setFilter({
      ...filter,
      sort: e.target.value === "" ? null : e.target.value
    });
  };

  const handleAgentIDChanged = e => {
    setShowModal(false);
    setAgent(e);
    setFilter(prev => ({
      ...prev,
      agentID: e.id === "" ? null : e.id
    }));
  };

  const classes = useStyles();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>AGENT BOOKING PROMO CODE</h4>
          </CardHeader>
          <CardBody>
            {(token["booking.agent_booking_promo_codes.write"] === "allowed" ||
              token.is_admin === "True") && (
              <Link to={"/admin/AgentBookingPromoCodes/Create"}>
                <Button color="rose" type="button" value="Create">
                  Create Promo Code
                </Button>
              </Link>
            )}
            <GridContainer>
              <GridItem xs={12} md={6}>
                <FormControl fullWidth className={classes.selectFormControl}>
                  <InputLabel htmlFor="selSort" className={classes.selectLabel}>
                    SORT BY
                  </InputLabel>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu
                    }}
                    classes={{
                      select: classes.select
                    }}
                    value={filter.sort ?? ""}
                    onChange={handleSortChanged}
                  >
                    {sortOptionsList.map(record => {
                      return (
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected
                          }}
                          value={record.value}
                          key={record.label}
                        >
                          <p>{record.label}</p>
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12} md={6}>
                <CustomInput
                  labelText="Search"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: handleSearchStringChanged,
                    value: filter.searchString ?? ""
                  }}
                />
              </GridItem>
              <GridItem xs={6}>
                <FormControl
                  fullWidth
                  className={classes.selectFormControl}
                  onClick={() => (!showModal ? setShowModal(true) : null)}
                  style={{ cursor: "pointer" }}
                >
                  <InputLabel
                    htmlFor="selAgent"
                    className={classes.selectLabel}
                    style={{ pointerEvents: "none" }}
                  >
                    Agent
                  </InputLabel>

                  <Input
                    className={classes.select}
                    value={agent ? agent.name : ""}
                    disabled
                    style={{ pointerEvents: "none" }}
                  />

                  <AgentDialog
                    openModal={showModal}
                    setOpenModal={val => setShowModal(val)}
                    onSelect={handleAgentIDChanged}
                  />
                </FormControl>
              </GridItem>
            </GridContainer>
            <ReactTable
              manual
              pages={pages}
              page={pagination.pageIndex - 1}
              pageSize={pagination.pageSize}
              onPageChange={page => {
                setPagination({
                  pageIndex: page + 1,
                  pageSize: pagination.pageSize
                });
              }}
              loading={loading}
              data={data}
              filterable={false}
              columns={[
                {
                  accessor: "promoCode",
                  Header: "Promo Code"
                },
                {
                  id: "effectiveFrom",
                  Header: "Effective Date",
                  accessor: d =>
                    d.effectiveFrom
                      ? formatDateTime(new Date(d.effectiveFrom + "Z"))
                      : "-"
                },
                {
                  id: "effectiveUntil",
                  Header: "Effective Until",
                  accessor: d =>
                    d.effectiveUntil
                      ? formatDateTime(new Date(d.effectiveUntil + "Z"))
                      : "-"
                },
                {
                  id: "discountAmount",
                  Header: "Discount Amount",
                  accessor: d =>
                    formatCurrency(
                      d.agent.billingCurrency === null
                        ? "XXX"
                        : d.agent.billingCurrency.code,
                      d.discountAmount
                    )
                },
                {
                  Header: "Minimal Pax",
                  accessor: "minimalPax"
                },
                {
                  Header: "Limit",
                  accessor: "limit"
                },
                {
                  Header: "Used",
                  accessor: "used"
                },
                {
                  Header: "On Hold",
                  accessor: "onHold"
                },
                {
                  Header: "Actions",
                  accessor: "actions",
                  sortable: false,
                  filterable: false
                }
              ]}
              defaultPageSize={10}
              showPaginationTop
              showPaginationBottom={false}
              className="-striped -highlight"
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
